import { render, staticRenderFns } from "./addView.vue?vue&type=template&id=10789310&scoped=true"
import script from "./addView.vue?vue&type=script&lang=js"
export * from "./addView.vue?vue&type=script&lang=js"
import style0 from "./addView.vue?vue&type=style&index=0&id=10789310&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10789310",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10789310')) {
      api.createRecord('10789310', component.options)
    } else {
      api.reload('10789310', component.options)
    }
    module.hot.accept("./addView.vue?vue&type=template&id=10789310&scoped=true", function () {
      api.rerender('10789310', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/baseInfo/koofee/appliance/addView.vue"
export default component.exports